import { Injectable } from '@angular/core';

@Injectable()
export class UserSessionService {

  constructor() { }

  public get(): string {
  
    return sessionStorage.getItem('token');
  }

  public set(token: string): void {
    
    sessionStorage.setItem('token', token);
  }

  public deleteToken(): void {
    sessionStorage.removeItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-session.service.ts